import React from "react"
export const GptScript: React.FC = () => {  
	return <script async src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"></script>
}
